export default "__VITE_ASSET__8OLrcr4S__"